import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Accordion from '../Accordion/Accordion';
import Exclusion from './Exclusion';
import { getServiceString } from './Utils';

import './Services.scss';

const COMPLETED_SERVICE_TYPE = 'ST01';

const getInvoiceTimestamp = (invoiceDate) => {
  const timestamp = Date.parse(invoiceDate);

  return Number.isNaN(timestamp) ? null : timestamp;
};

const sortServicesByNewestInvoiceDate = (firstService, secondService) => {
  const firstTimestamp = getInvoiceTimestamp(firstService?.InvoiceDate);
  const secondTimestamp = getInvoiceTimestamp(secondService?.InvoiceDate);

  if (firstTimestamp === null && secondTimestamp === null) {
    return 0;
  }

  if (firstTimestamp === null) {
    return 1;
  }

  if (secondTimestamp === null) {
    return -1;
  }

  return secondTimestamp - firstTimestamp;
};

const Services = ({ services }) => {
  const { t } = useTranslation();

  const processedServices = useMemo(() => {
    if (!Array.isArray(services)) {
      return [];
    }

    return services
      .filter((service) => service?.ServiceType === COMPLETED_SERVICE_TYPE)
      .sort(sortServicesByNewestInvoiceDate);
  }, [services]);

  if (processedServices.length === 0) {
    return null;
  }

  const latestService = processedServices[0];
  const serviceDescription = getServiceString(latestService.ServiceType, t);

  return (
    <Accordion title={t('servicesHeading')}>
      <div className="servicesWrapper">
        <div className="heading">{t('serviceType')}</div>
        <div className="description">{serviceDescription}</div>

        <Exclusion services={processedServices} />
      </div>
    </Accordion>
  );
};

export default Services;
